document.addEventListener("DOMContentLoaded", async () => {

// Detect login return to storefront:
const justLoggedIn =
    window.location.search.includes("logged_in") ||
    document.referrer.includes("/account/login") &&
    window.location.pathname === "/account";

// Detect logout redirect:
const justLoggedOut = document.referrer.includes("/account/logout");

const locationChanged = window.location.search.includes("company_location_changed")

if (justLoggedIn || justLoggedOut || locationChanged) {
    try {

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        let cartItemComponentsSectionIds = /** @type {string[]} */ ([]);
        cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
            cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
        });

        const url = `/cart/clear.js?sections=${cartItemComponentsSectionIds.join(",")}&section_url=${encodeURIComponent(window.location.pathname)}`;
        const response = await fetch(url, { method: 'POST' });
        const data = await response.json();
        // Re-render each section on the page
        for (const [sectionId, html] of Object.entries(data.sections)) {
            const el = document.querySelector(`[data-section-id='${sectionId}']`);
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newEl = doc.querySelector(`[data-section-id='${sectionId}']`);
            if (el && newEl?.outerHTML) {
                el.outerHTML = newEl.outerHTML;
            }
            const cartIcon = document.querySelector(`cart-icon`);
            const newCartIcon = doc.querySelector(`cart-icon`);
            if(cartIcon && newCartIcon?.outerHTML) {
                cartIcon.outerHTML = newCartIcon.outerHTML;
            }
        }
        // console.log("Cart cleared and sections updated.");
        sessionStorage.setItem(
            'cart-count',
            JSON.stringify({
              value: "0",
              timestamp: Date.now(),
            })
          );
        removeCompanyLocationChanged();

    } catch (e) {
    console.error("Cart clear failed:", e);
    }
}

function removeCompanyLocationChanged() {
    const url = new URL(window.location.href);
    url.searchParams.delete("company_location_changed");
    window.history.replaceState({}, "", url);
}
});